/* This is generated code, don't alter */
var IfcBeamTypeEnum;
(function (IfcBeamTypeEnum) {
    IfcBeamTypeEnum[IfcBeamTypeEnum["BEAM"] = 0] = "BEAM";
    IfcBeamTypeEnum[IfcBeamTypeEnum["JOIST"] = 1] = "JOIST";
    IfcBeamTypeEnum[IfcBeamTypeEnum["HOLLOWCORE"] = 2] = "HOLLOWCORE";
    IfcBeamTypeEnum[IfcBeamTypeEnum["LINTEL"] = 3] = "LINTEL";
    IfcBeamTypeEnum[IfcBeamTypeEnum["SPANDREL"] = 4] = "SPANDREL";
    IfcBeamTypeEnum[IfcBeamTypeEnum["T_BEAM"] = 5] = "T_BEAM";
    IfcBeamTypeEnum[IfcBeamTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcBeamTypeEnum[IfcBeamTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcBeamTypeEnum || (IfcBeamTypeEnum = {}));
const IfcBeamTypeEnumCount = 8;
export { IfcBeamTypeEnum, IfcBeamTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcBeamTypeEnum = new Int32Array([9, 0, 4]);
let prefixSumAddressIfcBeamTypeEnum = new Uint32Array([0, 7, 17, 29, 41, 54, 62, 70, 76]);
let slotMapIfcBeamTypeEnum = new Int32Array([1, 4, 7, 2, 6, 3, 5, 0]);
let encodedDataIfcBeamTypeEnum = (new TextEncoder()).encode(".JOIST..SPANDREL..NOTDEFINED..HOLLOWCORE..USERDEFINED..LINTEL..T_BEAM..BEAM.");
let IfcBeamTypeEnumSearch = new MinimalPerfectHash(gMapIfcBeamTypeEnum, prefixSumAddressIfcBeamTypeEnum, slotMapIfcBeamTypeEnum, encodedDataIfcBeamTypeEnum);
export { IfcBeamTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcBeamTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcBeamTypeEnumSearch, input, cursor, endCursor);
}
